import { css } from '@flipster/styled-system/css';
import { center } from '@flipster/styled-system/patterns';

import ChartLoadingIcon from './chart-loading.svg';

export const TvLoading = () => {
  return (
    <div
      className={css(
        center.raw({ pos: 'absolute', inset: 0, w: '100%', h: '100%', bgColor: 'background.default.level-0' }),
      )}
    >
      <ChartLoadingIcon />
    </div>
  );
};
